// Module
var code = `<main id="wrapper"> <section> <div class="w-20 mt7 ma0-auto tc error-container"> <img src="{{\$ctrl.errorIcon}}" alt=""> <h1 class="f1 bp-c-breeze mt3 mb3">Ops!</h1> <div class="b fw6 bp-c-time" ng-bind-html="\$ctrl.errorMsg"></div> </div> </section> </main> `;
// Exports
module.exports = code;